var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listRadioItem",style:(_vm.bgc),on:{"mouseover":_vm.mouseover,"mouseout":_vm.mouseout}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }